<!-- <tix-card>
  <tix-card-header>
    <tix-card-title>
      <button tix-icon-button [routerLink]="['/', 'company']"><tix-icon svgIcon="arrow-left"></tix-icon></button>
      {{ companyName$ | async }}
    </tix-card-title>
  </tix-card-header>
</tix-card> -->

<ng-container *ngIf="!(loading$ | async); else loadingState">
  <div class="header-bar" *ngIf="!isEditMode">
    <div class="header-title">Create New Company</div>
    <button tix-button>
      <tix-icon svgIcon="arrow-left-solid" [routerLink]="['../']"></tix-icon>
      <span class="add-button-text ml-2" [routerLink]="['../']">
        Go to Companies</span
      >
    </button>
  </div>

  <!--=====Tabs Container=====-->
  <div class="bg-white rounded-md border border-gray-200 shadow-sm">
    <mat-tab-group class="company-admin-tabs" animationDuration="300ms">
      <!-- Tab 1: Company Information -->
      <mat-tab label="Company Information">
        <div class="tab-content p-6">
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Basic Information</h3>
            </div>
            <div class="section-content">
              <tix-company-profile
                [companyId]="companyId$ | async"
                [companyName]="companyName$ | async"
                [companyWebsite]="companyUrl$ | async"
                [isloading]="companyProfilLoading$ | async"
                (saved)="saveCompanyProfile($event)"
              >
              </tix-company-profile>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab 2: Contact & Location -->
      <mat-tab label="Contact & Location" *ngIf="isNewCompany">
        <div class="tab-content p-6 space-y-6">
          <!-- Phone Numbers Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Phone Numbers</h3>
            </div>
            <div class="section-content">
              <tix-phone-numbers-edit
                [showHeader]="false"
                [pageName]="'companyDetails'"
                [phoneNumbers]="companyPhoneNumbers$ | async"
                [phoneTypesBusinessCodeGroup]="businessPhoneTypes$ | async"
                [isloading]="companyLoadingPhone$ | async"
                (delete)="deletePhoneNumber($event)"
                (save)="savePhoneNumbers($event)"
              >
              </tix-phone-numbers-edit>
            </div>
          </div>

          <!-- Addresses Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Addresses</h3>
            </div>
            <div class="section-content">
              <tix-address-edit
                [showHeader]="false"
                *ngIf="
                  (companyAddresses$ | async) &&
                  (businessStateProvinces$ | async) &&
                  (userId$ | async)
                "
                [addresses]="companyAddresses$ | async"
                [countries]="businessCountryCodes$ | async"
                [states]="businessStateProvinces$ | async"
                [isloading]="companyLoadingAdress$ | async"
                (save)="saveAddress($event)"
                [userId]="(userId$ | async) ?? ''"
              >
              </tix-address-edit>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab 3: Media & Social -->
      <mat-tab label="Media & Social" *ngIf="isNewCompany">
        <div class="tab-content p-6 space-y-6">
          <!-- Media Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Media Files</h3>
            </div>
            <div class="section-content">
              <tix-media-files-edit
                [showHeader]="false"
                [mediaFilesBusinessCodeGroup]="businessMediaFilesTypes$ | async"
                [mediaFiles]="companyMediaFiles$ | async"
                [isloading]="companyLoadingMediaFiles$ | async"
                (delete)="deleteMediaFile($event)"
                (save)="saveMediaFile($event)"
              >
              </tix-media-files-edit>
            </div>
          </div>

          <!-- Social Media Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Social Media</h3>
            </div>
            <div class="section-content">
              <tix-social-media-edit
                [showHeader]="false"
                [socialMediaBusinessCodeGroup]="
                  businessSocialMediaTypes$ | async
                "
                [socialMedias]="companySocialMedias$ | async"
                [isloading]="companyLoadingMedia$ | async"
                (delete)="deleteSocialMedia($event)"
                (save)="saveSocialMedias($event)"
              >
              </tix-social-media-edit>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Tab 4: Configurations -->
      <mat-tab label="Configurations" *ngIf="isNewCompany">
        <div class="tab-content p-6 space-y-6">
          <!-- Warning Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Warning Messages</h3>
            </div>
            <div class="section-content">
              <tix-warning
                [showHeader]="false"
                [warningBusinessCodeGroup]="businessWarningTypes$ | async"
                [warnings]="companyWarnings$ | async"
                (save)="saveWarnings($event)"
                (delete)="deleteWarning($event)"
                class="w-full"
              ></tix-warning>
            </div>
          </div>

          <!-- Communications Section -->
          <div class="section-card">
            <div class="section-header">
              <h3 class="section-title">Communications</h3>
            </div>
            <div class="section-content">
              <tix-company-communication [companyId]="companyId">
              </tix-company-communication>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-container>

<ng-template #loadingState>
  <div class="flex items-center justify-center min-h-96 py-8">
    <tix-loading-state
      [isLoading]="true"
      [hasError]="false"
      type="inline"
      loadingText="Loading Company Details"
      loadingSubText="Setting up your company administration panel..."
    ></tix-loading-state>
  </div>
</ng-template>
